<template>
  <v-container fluid class="department-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
          centered
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Department
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab
            class="mr-5"
            :href="`#tab-photos`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Display Photos
          </v-tab>
          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Department</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'departmentcode')"
                        v-bind:value="initvalue.departmentcode"
                        placeholder="Department Code"
                        persistent-hint
                        single-line hint="Enter the department code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'departmentname')"
                        v-bind:value="initvalue.departmentname"
                        placeholder="Department Name"
                        persistent-hint
                        single-line hint="Enter the department name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.departmenttype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'departmenttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the department type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'departmentstatus')"
                          v-bind:label="initvalue.departmentstatus"
                          v-model="initvalue.departmentstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/department/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editDepartment()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/department/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photos'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                  <v-form>
                    <p class="text-h5">Upload Photo</p>
                    <div class="d-flex justify-center">
                    <v-file-input label="Upload Image" clearable v-model="filename" v-on:change="onUploadChange" accept="image/*" />
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="uploadPhotos()">
                            Upload
                          </v-btn>
                    </div>
                  </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                  <v-row>
                  <v-col md="4" v-for="image in images" :key="image">
                      <div class="text-center">
                        <v-img contain max-height="150" max-width="250" :src="image" />
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="primary"
                            @click="deletePhotos(image)"
                          >
                            <v-icon dark>
                              mdi-close
                            </v-icon>
                          </v-btn>
                      </div>
                  </v-col>
                  </v-row>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-spacer></v-spacer>
                        <v-btn
                            to="/department/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Done
                        </v-btn>
                      </div>
                  </v-col>
                </v-row>
                <v-spacer min-height="20">&nbsp;</v-spacer>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      department: {},
      detail: {},
      photo: {},
      
      filename: null,
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      imageurl: undefined,
      images: [],
      upload: {},
      items: ['Department', 'Other Department'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Department', [
      'updateDepartmentRequest',
      'updateDepartmentImageRequest',
      'updateDepartmentPinRequest',
      'getDepartmentsRequest'
    ]),
    editDepartment() {
      this.department._id = this.initvalue._id;
      this.updateDepartmentRequest(this.department);
      this.getDepartmentsRequest();
      router.push('/department/list');
    },
    editDetail() {
      this.detail._id = this.initvalue._id;
      this.updateDepartmentRequest(this.detail);
      this.getDepartmentsRequest();
      router.push('/department/list');
    },
    editPhoto() {
      console.log(this.photo)
      this.photo._id = this.initvalue._id;
      this.updateDepartmentImageRequest(this.photo);
      this.getDepartmentsRequest();
      router.push('/department/list');
    },
    editPin() {
      console.log(this.pin);
      if(this.pin.departmentpin == undefined || this.pin.departmentpin.length<6){
        this.pin.error = true;
        return;
      }
      this.pin.error = false;
      if(this.pin.departmentpin !== this.pin.departmentpin2){
        this.pin.error2 = true;
        return;
      }
      this.pin.error2 = false;
      this.pin._id = this.initvalue._id;
      console.log(this.pin);
      this.updateDepartmentRequest(this.pin);
      this.getDepartmentsRequest();
      router.push('/department/list');
    },
    updateChangedValue(value, field){
      console.log(value, field);
      this.department[field] = value;
    },
    updateChangedDetail(value, field){
      console.log(value, field);
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.departmentimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.departmentimage = file;
      this.upload.imagename = file.name;
      console.log(this.upload);
    },
    uploadPhotos() {
      if(this.filename == null) return; 
      this.upload._id = this.initvalue._id;
      this.uploadItemImages(this.upload);
    },
    deletePhotos(imageurl) {
      console.log(imageurl);
      let del = {
        departmentimage: imageurl,
        _id: this.initvalue._id,
      }
      this.deleteItemImages(del);
    },
    deleteItemImages(payload) {
      console.log(payload);
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      var url = 'https://api.tradexc.com:3000/delete/department/images/' + id;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var del = {
        method: "delete",
        url: url,
        headers: header,
        data: payload,
      };

      axios(del)
      .then( (response)=> {
        this.images = response.data.departmentimages;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    },
    uploadItemImages(payload) {
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];   
      var url = 'https://api.tradexc.com:3000/add/department/images/' + id;
      data = new FormData();
      data.append('image', payload.departmentimage, payload.imagename); 
      delete payload['departmentimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then( (response)=> {
        this.images = response.data.departmentimages;
        this.filename = null;
      })
      .catch((error) => {
        console.error('Error:', error);
        this.filename = null;
      });
    },
  },
  computed: {
    ...mapState('Department', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.departmentimage;
    this.images = this.initvalue.departmentimages;
    if(!this.initvalue._id) this.$router.push({ name: 'DepartmentList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
